import { FC, useId } from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectProps } from "@mui/material";
import { LabelItemType } from "@/types/view";

type AppSelectProps = SelectProps & {
  data: LabelItemType[];
};

const AppSelect: FC<AppSelectProps> = ({ data, label, onChange, ...otherProps }) => {
  const labelId = useId();

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select label={label} labelId={labelId} onChange={onChange} {...otherProps}>
        {data.map(item => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AppSelect;
